import { render } from "./alert-square.vue?vue&type=template&id=3b42bda8"
import script from "./alert-square.vue?vue&type=script&lang=js"
export * from "./alert-square.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__